import React, { useRef, useState } from 'react';
import emailjs from '@emailjs/browser';
import style from "./ContactUs.module.css"
import ReCAPTCHA from 'react-google-recaptcha';

export const ContactUs = () => {
  const form = useRef();
  const [deliveryStatus, setDeliveryStatus] = useState(null);

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm('service_l2xnh8m', 'template_verh0kg', form.current, 'HniaRWWFuk-fFZ3h3')
        .then((result) => {
          setDeliveryStatus("Delivered");
          form.current.reset();
        })
        .catch((error) => {
          setDeliveryStatus("Failed to deliver");
        });
  };

  function onChange(value) {
    console.log("Captcha value:", value);
  }

  return (
      <div className={style.body}>
        <form className={style.form} ref={form} onSubmit={sendEmail}>
          <label>Name</label>
          <input type="text" name="user_name" placeholder='Full Name' />
          <label>Email</label>
          <input type="email" name="user_email" placeholder='Email' />
          <label>Message</label>
          <textarea className={style.textarea} name="message" placeholder='Message' />
          <ReCAPTCHA
              className={style.captcha}
              sitekey="6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI"
              onChange={onChange}
          />
          <button className={style.glow_on_hover} type="submit" value="Send" >Send</button>
          {deliveryStatus && <p>{deliveryStatus}</p>}
        </form>
      </div>
  );
};
